var map = {
	"./berlinfuchs/directions.jpg": 32,
	"./berlinfuchs/locations.jpg": 33,
	"./berlinfuchs/menu.jpg": 34,
	"./berlinfuchs/mobile.jpg": 35,
	"./berlinfuchs/overlay-animation.mp4": 36,
	"./berlinfuchs/project-header.jpg": 37,
	"./berlinfuchs/project-logo.png": 38,
	"./berlinfuchs/project-preview.jpg": 9,
	"./digital-data-collection/project-header.jpg": 39,
	"./digital-data-collection/project-logo.svg": 40,
	"./digital-data-collection/project-preview.jpg": 10,
	"./digital-data-collection/site.jpg": 41,
	"./digital-data-collection/transition.mp4": 42,
	"./droplet/edit-project.jpg": 43,
	"./droplet/login.mp4": 44,
	"./droplet/opengraph.png": 45,
	"./droplet/project-logo.png": 46,
	"./droplet/project-preview.jpg": 11,
	"./droplet/table-navigation.mp4": 47,
	"./droplet/terminal-feature.png": 12,
	"./dynamic-polyfill-module/project-logo.svg": 48,
	"./dynamic-polyfill-module/project-preview.jpg": 13,
	"./maria-jose-moreno/project-header.jpg": 49,
	"./maria-jose-moreno/project-logo.png": 50,
	"./maria-jose-moreno/project-preview.jpg": 14,
	"./maria-jose-moreno/slider.mp4": 51,
	"./maria-jose-moreno/transition.mp4": 52,
	"./robots-and-ai/content.jpg": 53,
	"./robots-and-ai/project-header.png": 54,
	"./robots-and-ai/project-logo.png": 55,
	"./robots-and-ai/project-preview.jpg": 15,
	"./robots-and-ai/transition.mp4": 56,
	"./zissel/bottles.mp4": 57,
	"./zissel/comparison.jpg": 58,
	"./zissel/hero.jpg": 59,
	"./zissel/laurels.mp4": 60,
	"./zissel/project-header.jpg": 61,
	"./zissel/project-logo.png": 62,
	"./zissel/project-preview.jpg": 16
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6;


//////////////////
// WEBPACK FOOTER
// ./assets/projects ^\.\/.*$
// module id = 6
// module chunks = 0